import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLogoutMutation, api } from '../api';
import { useAlert } from './useAlert';
import { useTranslation } from './useTranslation';

/**
 * Хук для выхода из системы
 * Вызывает API метод logout и при успехе очищает стор и перенаправляет на страницу логина
 * В случае ошибки показывает alert
 */
export const useLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { error: showError } = useAlert();
    const { t } = useTranslation();

    const [logoutApi, { isLoading, error }] = useLogoutMutation();

    const logout = async () => {
        try {
            await logoutApi().unwrap();
            // Очищаем весь кэш RTK Query
            dispatch(api.util.resetApiState());
            // Перенаправляем на страницу логина
            navigate('/login');
        } catch (error) {
            // Показываем alert с ошибкой
            showError(t.login.errors.logoutError);
        }
    };

    return { logout, isLoading, error };
};
